import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "card-slider" }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = { class: "card-slider-wrapper" }

import Equalize from '@/utils/Equalize';
import {
  onBreakpointChanged,
  removeOnBreakpointChanged,
} from '@/utils/viewport';
import {
  computed,
  inject,
  nextTick,
  onBeforeUnmount,
  onMounted,
  onUpdated,
  Ref,
  ref,
  useSlots,
  h,
  VNode,
} from 'vue';
import {
  Carousel,
  Slide,
} from 'vue3-carousel';
import 'vue3-carousel/dist/carousel.css';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faChevronsRight,
  faChevronsLeft,
} from '@fortawesome/pro-solid-svg-icons';
import BranchInterface from '@/interfaces/BranchInterface';


export default /*#__PURE__*/_defineComponent({
  __name: 'CardSlider',
  props: {
    branch: {},
    arrowsActive: { type: Boolean }
  },
  setup(__props: any) {

library.add(faChevronsRight, faChevronsLeft);

const carouselEl = ref<InstanceType<typeof Carousel>>();

const props = __props;

const slots = useSlots();
const slotDefault = computed(() => (slots.default ? slots.default() : null));
const slideItems = ref<VNode[]>([]);
const numItems = computed<number>(() => slideItems.value.length);

const toPrev = () => {
  if (!carouselEl.value) return;

  carouselEl.value.prev();
};

const toNext = () => {
  if (!carouselEl.value) return;

  carouselEl.value.next();
};

const isMobileBreakpoint = inject('isMobileBreakpoint') as Ref<boolean>;

const showNavigation = computed(() => (
  isMobileBreakpoint.value
    ? numItems.value > 1
    : numItems.value > 3
));
const itemsToShow = ref<number>(1);
const allowDrag = ref<boolean>(true);

const setItemsToShow = (event: CustomEvent) => {
  const breakpoints = event.detail?.breakpoints || [] as string[];
  const lastBreakpoint = [...(breakpoints || [])].reverse()[0] || 'xs';

  switch (lastBreakpoint) {
    case 'sm':
      itemsToShow.value = 2;
      allowDrag.value = true;
      break;
    case 'md':
      itemsToShow.value = 2;
      allowDrag.value = true;
      break;
    case 'lg':
      itemsToShow.value = 2;
      allowDrag.value = true;
      break;
    case 'xl':
      itemsToShow.value = 2;
      allowDrag.value = false;
      break;
    case 'xxl':
    case 'xxxl':
      itemsToShow.value = 3;
      allowDrag.value = false;
      break;
    default:
      itemsToShow.value = 1;
      allowDrag.value = true;
  }
};

const containerEl = ref<HTMLElement>();
const triggerAutoEqualize = () => {
  if (!containerEl.value) return;

  Equalize.run(containerEl.value);
};

const preventMapSlotItems = ref<boolean>(false);
const mapDefaultSlotItems = () => {
  if (preventMapSlotItems.value) {
    preventMapSlotItems.value = false;
    return;
  }
  let items: any[] = [];
  if (typeof slotDefault.value?.[0]?.type === 'symbol') {
    items = (slotDefault.value?.[0]?.children || []) as any[];
  } else {
    items = slotDefault.value || [];
  }

  preventMapSlotItems.value = true;
  nextTick(() => {
    slideItems.value = [...items].map((item: any) => h(Slide, {
      class: 'card-slider__item',
    }, () => [h('div', {
      class: 'card-slider__item-wrapper',
    }, [item])]));

    onBreakpointChanged(setItemsToShow, true);

    setTimeout(triggerAutoEqualize, 50);
  });
};

onMounted(mapDefaultSlotItems);

onUpdated(triggerAutoEqualize);
onUpdated(() => {
  mapDefaultSlotItems();
});

onBeforeUnmount(() => {
  removeOnBreakpointChanged(setItemsToShow);
});

return (_ctx: any,_cache: any) => {
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      ref_key: "containerEl",
      ref: containerEl,
      class: "card-slider-container"
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (slideItems.value.length)
              ? (_openBlock(), _createBlock(_unref(Carousel), {
                  key: 0,
                  ref_key: "carouselEl",
                  ref: carouselEl,
                  class: _normalizeClass(["io-eq", { 'mobil': _unref(isMobileBreakpoint) }]),
                  "items-to-show": itemsToShow.value,
                  transition: 1025,
                  "mouse-drag": allowDrag.value,
                  "wrap-around": showNavigation.value,
                  "snap-align": "start",
                  onSlideStart: triggerAutoEqualize
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(slideItems.value, (slideItem, inx) => {
                      return (_openBlock(), _createBlock(_resolveDynamicComponent(slideItem), {
                        key: `slide-item-${inx}`
                      }))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["class", "items-to-show", "mouse-drag", "wrap-around"]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      (showNavigation.value && !allowDrag.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", {
              class: "card-slider__prev",
              style: _normalizeStyle({
            color: `${props.branch?.customColor.primary}`,
          }),
              onClick: toPrev
            }, [
              _createVNode(_component_FontAwesomeIcon, { icon: "fa-solid fa-chevrons-left" })
            ], 4),
            _createElementVNode("div", {
              class: "card-slider__next",
              style: _normalizeStyle({
            color: `${props.branch?.customColor.primary}`,
          }),
              onClick: toNext
            }, [
              _createVNode(_component_FontAwesomeIcon, { icon: "fa-solid fa-chevrons-right" })
            ], 4)
          ], 64))
        : _createCommentVNode("", true)
    ], 512),
    (showNavigation.value && allowDrag.value && props.arrowsActive)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", {
            class: "card-slider__prev-mobile",
            style: _normalizeStyle({
            color: `${props.branch?.customColor.primary}`,
          }),
            onClick: toPrev
          }, [
            _createVNode(_component_FontAwesomeIcon, { icon: "fa-solid fa-chevrons-left" })
          ], 4),
          _createElementVNode("div", {
            class: "card-slider__next-mobile",
            style: _normalizeStyle({
            color: `${props.branch?.customColor.primary}`,
          }),
            onClick: toNext
          }, [
            _createVNode(_component_FontAwesomeIcon, { icon: "fa-solid fa-chevrons-right" })
          ], 4)
        ], 64))
      : _createCommentVNode("", true)
  ], 64))
}
}

})